import { apiBase } from "APIs/index";

export const AI_getIncidents = apiBase.createInstance({
  endpoint: "/get-incident/{id}",
  method: "get",
  reducer: "incidentsReducer",
  key: "id",
  reduxKey: "IncidentsData",
  action: "GET_INCIDENTS",
  onSuccess: (data) => data,
});

export const AI_getAllIncidents = apiBase.createInstance({
  endpoint: "/get-all-incidents",
  method: "get",
  reducer: "incidentsReducer",
  key: "id",
  reduxKey: "IncidentsData",
  action: "GET_ALL_INCIDENTS",
  onSuccess: (data) => data,
});

export const AI_getIncidentEmp = apiBase.createInstance({
  endpoint: "/get-incident-employee",
  method: "get",
  reducer: "incidentsReducer",
  key: "id",
  reduxKey: "IncidentsData",
  action: "GET_ALL_INCIDENTS_EMPLOYEE",
  onSuccess: (data) => data,
});

export const AI_addIncident = (employeeid,filterParams) => 
  apiBase.createInstance({
    endpoint: "/incident",
    method: "post",
    reducer: "incidentsReducer",
    reduxKey: "IncidentsData",
    action: "ADD_INCIDENTS",
    onSuccess: (data) => {
      if(employeeid) {
        AI_getIncidents.call({ urlParams: { id: employeeid } });
      }else{
        AI_getAllIncidents.call({
             params: {
            ...filterParams,
            },
        });
      }
      return data;
    }
});

export const AI_updateIncident = (employeeid,filterParams) =>
  apiBase.createInstance({
    endpoint: "/update-incident/{id}",
    method: "put",
    reducer: "incidentsReducer",
    reduxKey: "IncidentsData",
    action: "UPDATE_INCIDENTS",
    onSuccess: (data) => {
      if(employeeid) {
        AI_getIncidents.call({ urlParams: { id: employeeid } });
      }else{
        console.log("filterParams:",filterParams)
        AI_getAllIncidents.call({
             params: {
            ...filterParams,
            },
        });
      }
      
      return data;
    }
});

export const AI_deleteIncident = (employeeid,filterParams) =>
  apiBase.createInstance({
    endpoint: "/delete-incident/{id}",
    method: "put",
    reducer: "incidentsReducer",
    reduxKey: "IncidentsData",
    action: "DELETE_INCIDENTS",
    onSuccess: (data) => {
      if(employeeid) {
        AI_getIncidents.call({ urlParams: { id: employeeid } });
      }else{
        AI_getAllIncidents.call({
             params: {
            ...filterParams,
            },
        });
      }
      return data;
    }
});


